const createOptionObject = label => ({ label, href: `#${label}` })

const mapMenuOptions = sections => {
  const options = sections.map(({ id }) => createOptionObject(id))
  options.unshift(createOptionObject('HOME'))
  return options
}

export default mapMenuOptions
